export default __webpack_public_path__ + "static/media/dashboard.623a2091.svg";